import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Card, Button, CardGroup, Spinner } from 'react-bootstrap';
import { ArrowUpRightCircle } from '@styled-icons/bootstrap/ArrowUpRightCircle';

//Actions
import { pesquisaCategorias } from '../../actions/forms/validacao';
import { pesquisa as pesquisatraducoes } from '../../actions/traducoes/traducoes';

//PACKS
import { withRouter } from 'react-router-dom';

//Components
import EventoNaoEncontrado from '../../components/evento/EventoNaoEncontrado';
import Body from '../../components/layoutcredenciamento/Body';
import Footer from '../../components/layoutcredenciamento/Footer';
import Header from '../../components/layoutcredenciamento/Header';
import Layout from '../../components/layoutcredenciamento/Layout';

//Utils
import { 
    getDecodeEvento, 
    setCategoriaCred, 
    setCategoriaCredDescricao, 
    setEvento, 
    setLogoutusercred, 
    setListenerProdutoRemovido,
    setAcessoLinkCategoriaDireto } from '../../utils/eventosessioncred';

const CarregarEvento = (props) => {
    const [categorias, setCategorias] = useState([]);
    const [linguagem, getLinguagem] = useState('pt');
    const [evento, setEventoCarregado] = useState(false);
    
    const load = async () => {
        const result_pesquisa = await getDecodeEvento(props, 'imagemevento');        
        await props.pesquisatraducoes(
            {
                ...{ idevento: result_pesquisa.idevento, idpromotora: result_pesquisa.idpromotora },
                wherein: JSON.stringify({
                    campo: 'identificador',
                    valores: ['conf_index']
                })
            }
        );
        if (result_pesquisa && result_pesquisa.idevento) {            
            setEvento(result_pesquisa);
            setEventoCarregado(result_pesquisa);
            setCategorias(await props.pesquisaCategorias({ idevento: result_pesquisa.idevento, idpromotora: result_pesquisa.idpromotora }));
        }
    }

    useEffect(() => {
        load();
        setListenerProdutoRemovido([]);
        setLogoutusercred();//Foi para tela de login, zera as sessões do usuário  
        setAcessoLinkCategoriaDireto(false);
    }, []);

    useEffect(() => {        
        if(props.match.params.categoria){
            const categoria_url = categorias.filter(itens => (itens.categoria===props.match.params.categoria));                        
            if(categoria_url[0]){
                setAcessoLinkCategoriaDireto(props.match.params.categoria);
                handleRedirect(categoria_url[0].baseformcategoria, true);
            }
        }
    },[categorias]);

    const handleRedirect = (iten, automatico = false) => {        
        setCategoriaCred(iten.categoria);
        setCategoriaCredDescricao(JSON.stringify({
            descricao_pt: iten.descricao,
            descricao_en: iten.descricao_en,
            descricao_es: iten.descricao_es
        }));
        
        switch (iten.categoria) {            
            default:
                if(automatico){
                    props.history.push(`/credenciamento/${props.match.params.promotora}/${props.match.params.evento}/login`);
                }else{
                    props.history.push(`${props.match.url}/login`);
                }
        }
    }

    if (evento === false) {
        return <Card><Spinner style={{ margin: "auto" }} animation="border" /></Card>;
    }

    if (!evento.idevento) {
        return (
            <EventoNaoEncontrado />
        );
    }

    return (
        <Layout>
            <Header getLinguagem={getLinguagem} getCategoria={null} prelogin={true} />
            <Body>
                <CardGroup>
                    {categorias.map((iten, indice) => {
                        return (
                            <Card key={indice}>
                                <Card.Body>
                                    <Card.Title>{iten.baseformcategoria[`${linguagem === 'pt' ? 'descricao' : `descricao_${linguagem}`}`]}</Card.Title>
                                    <Button variant="primary" onClick={() => handleRedirect(iten.baseformcategoria)} block><ArrowUpRightCircle size="25" /></Button>
                                </Card.Body>
                            </Card>
                        )
                    })}
                </CardGroup>
            </Body>
            <Footer />
        </Layout>
    );
}

export default connect(null, { pesquisaCategorias, pesquisatraducoes })(withRouter(CarregarEvento));